<template>
    <div class="container-fluid mt-7">
        <div class="card">
            <base-header class="pb-6" type="">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 d-inline-block mb-0">Status</h6>
                    </div>
                    <div class="col-lg-6 col-5 text-right">
                        <base-button @click="callAllApis()" size="sm" type="neutral">
                            <i class="fas fa-sync-alt"></i> Refresh
                        </base-button>
                    </div>
                    <div v-if="holiday && holidayDescription"
                        class="alert alert-gray d-flex align-items-center justify-content-end notification-bar w-100 p-0 mt-4 mr-3 flex-wrap">
                        <i class="fas fa-bell text-danger mr-2"></i>
                        <span class="text-dark font-weight-bold">Upcoming Holiday:</span>
                        <div class="ml-2 d-block d-sm-inline-block text-left">
                            <i class="fas fa-calendar-days mr-2 ml-2"></i>
                            <span class="text-dark font-weight-bold">{{ holiday }}</span>
                            <span class="text-danger ml-2">{{ holidayDescription }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-1">
                                <div v-if="statusText === 'Running'" class="mb-2">
                                    <i class="fas fa-circle-check text-success fa-3x mb-2"></i>
                                </div>
                                <div v-else-if="statusText === 'Stopped'" class="mb-2">
                                    <i class="fas fa-circle-exclamation text-danger fa-3x mb-2"></i>
                                </div>
                                <div v-else class="mb-3">
                                    <i class="fas fa-sync fa-spin text-white fa-2x mb-2"></i>
                                </div>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Status</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Status of Itrade application</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ variations || 0 }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Variations</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Sum of strategies subscribed by each user
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ instruments || 0 }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Instruments</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Number of instruments running</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0"
                                    :class="{ 'enabled-action': loginFailedCount > 0 }" @click="navigateToUsers">
                                    {{ loginFailedCount }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">User Login Failed</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Number of unsuccessful logins</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ formattedAmountInvested }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Amount Invested</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Total capital invested by users</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                                    {{ activeUsers }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Active Users</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Number of active users</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <div v-if="feeder === 'Connected'" class="mb-2">
                                    <i class="fas fa-circle-check text-success fa-3x mb-2"></i>
                                </div>
                                <div v-else class="mb-2">
                                    <i class="fas fa-circle-xmark fa-3x text-danger mb-2"></i>
                                </div>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Feeder</h4>
                                <p class="mb-0 opacity-8 text-white h6 px-1">Tick provider connection status</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2 col-md-3 col-md-card col-sm-card">
                        <div class="card bg-gradient-info border-0 h-75">
                            <div class="card-body text-center px-0">
                                <h1 :class="['font-weight-bolder', 'card-header-font', 'mb-0', pnlTextColor]">
                                    {{ pnl || 0 }}
                                </h1>
                                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">P&L</h4>
                                <p class="mb-0 opacity-8 text-white h6">Today's Profit & loss</p>
                            </div>
                        </div>
                    </div>
                </div>
            </base-header>
        </div>
    </div>
</template>
<script>
import { registerSubscriber, disconnect, send } from '../System/statusWebsocket';
export default {
    data() {
        return {
            currentDateTime: "",
            tickTime: "",
            tickCommand: "lastTick",
            holiday: "",
            holidayDescription: "",
            applicationStatus: "",
            variations: "",
            instruments: "",
            loginFailedCount: 0,
            activeUsers: 0,
            amountInvested: 0,
            pnl: 0,
        };
    },
    created() {
        registerSubscriber(this.onMessageReceived);
        setInterval(() => {
            send(this.tickCommand);
        }, 1000);
    },
    methods: {
        updateDateTime() {
            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = now.getFullYear();
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");
            this.currentDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        },
        onMessageReceived(receivedMessage) {
            if (receivedMessage.command === 'lastTick') {
                const tick = receivedMessage.response;
                this.tickTime = this.formatDateTime(tick);
            }
        },
        formatDateTime(dateTimeString) {
            const date = new Date(dateTimeString);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        },
        getHolidayData() {
            this.$store.dispatch("holidayStore/getUpcomingHoliday", { root: true })
                .then(response => {
                    const holiday = response.server.data[0].day;
                    const date = new Date(holiday);
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const year = date.getFullYear();
                    this.holiday = `${day}/${month}/${year}`;
                    this.holidayDescription = response.server.data[0].description;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getStatusInfo(dataType) {
            let data = {
                type: dataType
            };
            this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
                .then(response => {
                    this.applicationStatus = response.server.data.status;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getStatusVariation() {
            this.$store.dispatch("statusDashboard/getStatusVariation", { root: true })
                .then(response => {
                    this.variations = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getInstrumentsCount() {
            this.$store.dispatch("statusDashboard/getInstrumentsCount", { root: true })
                .then(response => {
                    this.instruments = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getFeederStatus() {
            this.$store.dispatch("statusDashboard/getFeederStatus", { root: true })
                .then(response => {
                    const status = response.server.data;
                    if (status == "Connected") {
                        this.feeder = "Connected";
                    } else {
                        this.feeder = "Not connected";
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getUserLoginFailedCount() {
            this.$store.dispatch("statusDashboard/getUserLoginFailedCount", { root: true })
                .then(response => {
                    const data = response.server.data
                    this.loginFailedCount = data.length;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getActiveUsersCount() {
            let data = {
                type: 'active-users'
            };
            if (sessionStorage.getItem(data.type + "-reference-data")) {
                const result = JSON.parse(sessionStorage.getItem(data.type + "-reference-data"))
                this.activeUsers = result.length;
            } else {
                this.$store.dispatch("commonStore/getReferenceData", data, { root: true })
                    .then(response => {
                        const resultData = response.server.data;
                        this.activeUsers = resultData.length;
                        sessionStorage.setItem(data.type + "-reference-data", JSON.stringify(resultData));
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        callAllApis() {
            this.getHolidayData();
            this.getStatusInfo("APPLICATION_STATUS");
            this.getStatusVariation();
            this.getInstrumentsCount();
            this.getFeederStatus();
            this.getUserLoginFailedCount();
            this.getActiveUsersCount();
            this.getAmountInvested();
            this.getPnl();
        },
        navigateToUsers() {
            if (this.loginFailedCount > 0) {
                this.$router.push({ path: '/system/users', query: { status: 'failed' } });
            }
        },
        getAmountInvested() {
            this.$store.dispatch("statusDashboard/getAmountInvested", { root: true })
                .then(response => {
                    this.amountInvested = response.server.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getPnl() {
            this.$store.dispatch("statusDashboard/getPnl", { root: true })
                .then(response => {
                    const data = response?.server?.data;
                    if (data === null || data === undefined || data === "") {
                        this.pnl = "--";
                    } else {
                        this.pnl = parseFloat(data).toFixed(2);
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.pnl = "--";
                });
        },
    },
    computed: {
        statusBackground() {
            let bgColor = '';
            if (this.applicationStatus == 'DOWN') {
                bgColor = 'bg-gradient-danger';
            } else if (this.applicationStatus == 'UP') {
                bgColor = 'bg-gradient-success';
            }
            return bgColor;
        },
        statusText() {
            let text = '';
            if (this.applicationStatus == 'DOWN') {
                text = 'Stopped';
            } else if (this.applicationStatus == 'UP') {
                text = 'Running';
            }
            return text;
        },
        pnlTextColor() {
            if (this.pnl > 0) return 'text-success';
            if (this.pnl < 0) return 'text-danger';
            return 'text-white';
        },
        formattedAmountInvested() {
            if (!this.amountInvested) return '0';
            return (this.amountInvested / 10000000).toFixed(2) + ' Cr';
        }
    },
    mounted() {
        this.updateDateTime();
        this.timer = setInterval(this.updateDateTime, 1000);
        this.callAllApis();
        this.apiTimer = setInterval(this.callAllMethods, 120000);
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.apiTimer);
        disconnect();
    },
};
</script>
<style></style>
